/**
 * Product IDs for subscription products across all republics
 * These IDs correspond to the products defined in Stripe/payment system
 */
export const STRIPE_PRODUCT_IDS = {
  ESSENTIAL_MONTHLY: 'prod_RqTbYsPalQ3AfM',
  ESSENTIAL_ANNUALLY: 'prod_RqTezToe62ITrO',
  PREMIUM_MONTHLY: 'prod_QkHK6SYqqUnkLC',
  PREMIUM_ANNUALLY: 'prod_QkHLnJhTVhERhy',
  WHOSCORED_PLUS_MONTHLY: 'prod_SsACNCOh4v7G84',
  GAZZETTA_PLUS_MONTHLY: 'prod_GZ_PLUS_MONTHLY',
  // This Stripe product ID retains the legacy 'ANNUAL' suffix from when it was an annual plan.
  // The underlying Stripe product has been repurposed as a 3-month prepaid plan.
  GAZZETTA_PLUS_THREE_MONTHLY: 'prod_GZ_PLUS_ANNUAL',
} as const;

export type ProductId = (typeof STRIPE_PRODUCT_IDS)[keyof typeof STRIPE_PRODUCT_IDS];
